const InvoiceLineTypes = {
    CALENDAR: 1,
    NEWSLETTER: 2,
    DIGITAL_FILE: 3,
    PRINTED_EXTRA: 4,
    BIRTHDAY_POSTER: 5,
    SUBSCRIPTION: 6,
    RUSH_PROCESSING: 7,
    CUSTOM_CHARGE: 8,
    DISCOUNT: 9,
    CUSTOM_LINE: 10,
    SALES_TAX: 11,
    SHIPPING_FEE: 12,
};

export default InvoiceLineTypes;
